import { render } from "./NotFound.vue?vue&type=template&id=0f9ac78c"
const script = {}
script.render = render

export default script